import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import _com from "../../../assets/js/common";
import cookie from "../../../assets/js/cookie"

@Component
export default class goodsModal extends Vue {
	@Prop() diff: any = 0
	isShow: Boolean = true   // 控制分类列表展示隐藏
	batchTitle: String = ""; //商品关联优惠券信息
	shopGoods: String = ""; //商品展示
	browser = _com.browser();
	difference: number = 0;//本地时间与服务器时间差值
	previewList: any = {};  // 商品预览列表
	activeIndex: String = '0'  // 选中的分类，默认全部
	searchBox: Boolean = true
	searchVal: String = ''
	searchMsg: String = ''
	isShowTag: Boolean = false
	environment: any
	environmentUrl: any
	showNavigation: any = true
	searchList: any = []
	toSeckillLiveData: any
	urlData: any = {}
	get clientType() {
		return this.$store.getters["environment/getClientType"];
	}
    get isElderlyMode (){
        return this.$store.getters["environment/getElderlyMode"];
    }	
	get roomData() {//房间数据
		return this.$store.getters["getRoomDetail/getRoomDetail"];
	}
	get ifBatchTitle() {
		return this.$store.getters["environment/getIfBatchTitle"];
	}

	get useronlyid() {
		return this.$store.getters["getUserOnlyId/getUserOnlyId"];
	}
	get hotGoodLists() {
		return this.$store.getters["refresh/getHotGoodList"]
	}
	get goodsList() {
		this.toSeckillLiveData = sessionStorage.getItem('toSeckillLiveData')
		let list: Array<any> = this.$store.getters["refresh/getGoodsList"];
		return this.listProce(list, true);
	}

	get recommendGoods() {
		//推荐商品
		let list: Object = this.$store.getters["refresh/getRecommend"];
		return this.listProce([list], false)[0];
	}

	get batchObj() {
		return this.$store.getters["environment/getBatchObj"];
	}
	get roomDetail() {
		return this.$store.getters["getRoomDetail/getRoomDetail"];
	}
	api = {
		getProduct: process.env.VUE_APP_URI_CDNDOMAIN + "/ulelivebarrage/api/v1/introduce/static/product/",
		getHotGoods: process.env.VUE_APP_URI_CDNDOMAIN + "/ulelivebarrage/api/v1/room/hotGoods/query",  // 查询爆款商品
	};

	timeInter: any;
	@Watch("diff") // 更新接收的值  ，不然只会显示第一次接收到的值
	watchDiff(newVal: number) {
		this.difference = newVal;
	}
	created() {
		let ua = navigator.userAgent.toLowerCase()
		this.showNavigation = ua.indexOf("zyetapp") == -1
	}
	mounted() {
		this.scTimer()
		this.volumeShop();
		this.isShowTag = this.roomData.tvType == 7 || this.roomData.tvType == 8
		if (this.isShowTag) {
			(this.domain.indexOf('beta') > -1 || this.domain.indexOf('testing') > -1) ? this.environment = 'sdycsdyc.cn' : this.environment = '100qu.net'
			if (location.href.indexOf('origin=yzlife') > -1) this.environmentUrl = 'yzlife' // 邮生活APP 邮生活公众号
			if (location.href.indexOf('origin=pmcc') > -1) this.environmentUrl = 'pmcc'   // 邮储信用卡APP
			let url = location.href
			let reg = /[?&]([^?&#]+)=([^?&#]+)/g;
			let param: any = {};
			let ret: any = reg.exec(url);
			while (ret) {//当ret为null时表示已经匹配到最后了，直接跳出
				param[ret[1]] = ret[2];
				ret = reg.exec(url);
			}
			this.urlData = param
		}

		if (this.$route.name == 'goosModal') {
			this.$store.dispatch("refresh/getRecommendAsync", {
				roomNumber: this.$route.params.roomNumber,
				source: this.$route.params.source || this.source
			}
			);
			let timeNum = 0;
			clearInterval(this.timeInter);
			this.timeInter = setInterval(() => {
				//定时5秒获取一次弹幕
				timeNum++;
				if (timeNum % 10 == 0) {
					timeNum = 0;
					this.$store.dispatch("refresh/getRecommendAsync", {
						roomNumber: this.$route.params.roomNumber,
						source: this.$route.params.source || this.source
					}
					);
				}
			}, 1000)
		}

	}
	scTimer() {
		let numTimeout = 0
		let that: any = this
		setTimeout(function (_: any) {
			if (numTimeout > 25) return false
			numTimeout++;
			if ((<any>window).uleStatUtil) {
				that.scExposure()
			} else {
				that.scTimer()
			}
		}, 1000)
	}
	scExposure() {
		try {
			let uploadLog: any = []
			let isFirst = true
			let client_Type = 'resourceExposure'
			let that = this
			let exCallBack = function (entries: any, observer: any) {
				// 第一次触发显示时会给所有的元素
				if (isFirst) {
					entries.forEach(function (item: any, index: any) {
						// var index = item.target.dataset.index
						uploadLog[index] = {
							isPush: false, // 是否上报过
							timer: -1 // 用于存储定时器编号
						}
					})
					isFirst = false
				}
				entries.forEach(function (item: any, index: any) {
					// var index = item.target.dataset.index
					// 先判断当前元素是否已经上报过日志
					if (uploadLog[index].isPush) {
						return false // 上报过直接 直接退出
					}
					if (item.isIntersecting) {
						// 开始计时, 500豪秒后添加神策数据
						uploadLog[index].timer = setTimeout(function (_: any) {
							let item_type = '商品'
							let scene_number = that.roomData.scene_number
							let roomNumber = that.$route.params.roomNumber
							let item_id = that.goodsList[index].listId
							let item_name = that.goodsList[index].listName
							let commodity_original_price = that.goodsList[index].priceRange    // 原价
							let commodity_current_price = that.goodsList[index].minPrice // 现价
							let current_page_name = '直播间商品列表弹窗' // 当前页名字
							let item_explain_status = that.recommendGoods.listId == that.goodsList[index].listId ? '讲解中' : ''; // 物品讲解状态

							let sysid: any = ''
							if (navigator?.userAgent.includes('SYSID')) {
								sysid = navigator.userAgent.split('SYSID/')[1]
							}
							let yzt_app_id: any = ''
							if (navigator?.userAgent.includes('APPID')) {
								yzt_app_id = navigator.userAgent.split('APPID/')[1].split(' SYSID')[0]
							}
							let yzt_bowdataId: any = ''
							if (navigator?.userAgent.includes('yzt_bowdataId')) {
								yzt_bowdataId = navigator.userAgent.split('yzt_bowdataId/')[1]
							}
							(<any>window).uleStatUtil && (<any>window).uleStatUtil.sendSensorTrack(client_Type, {
								item_type,
								item_id,
								sysid,
								scene_number,
								roomNumber,
								yzt_app_id,
								yzt_bowdataId,
								item_name,
								commodity_original_price,
								commodity_current_price,
								current_page_name,
								item_explain_status
							});
							// 上报完成后，状态修改为 true,避免重复上报
							uploadLog[index].isPush = true
						}, 100)
					} else {
						// 如果元素移动出可视区域后，清除定时器
						if (uploadLog[index].timer) clearTimeout(uploadLog[index].timer)
					}
				})
			}
			let observer = new IntersectionObserver(exCallBack, { threshold: 0.99 })
			let liList = document.querySelectorAll('.item li');
			liList.forEach(function (item) {
				observer.observe(item);
			})
		} catch (error) {
			console.log(error);
		}
	}
	launch() {
		this.isShow = !this.isShow
		let burialPoint = {
			url: location.href,
			ule_title: '直播间商品列表弹窗',
			button_name: '展开/收起',
			remarks: this.isShow ? '收起' : '展开'
		}
		_com.sendSensorTrack('btnClick', {}, burialPoint)
	}
	activeClassiFication(data: any): void {
		this.activeIndex = data
		let burialPoint = {
			url: location.href,
			ule_title: '直播间商品列表弹窗',
			button_name: data == '0' ? '全部' : data,
			remarks: data == '0' ? '全部' : data,
			scene_number: this.roomData.scene_number,
			roomNumber: this.$route.params.roomNumber
		}
		_com.sendSensorTrack('btnClick', {}, burialPoint)
	}
	roundUpToTwoDecimalPlaces = (num:any)=> { 
		if (typeof num == 'string') {
			num = Number(num)
		}
		if (!(/(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(num))){
			num = num.toFixed(4)/1
			var roundedNum = Math.ceil(num * 100) / 100;  
			return roundedNum.toFixed(2);  
		}else{
			return num.toFixed(2)
		}
	}	
	// 秒杀商品数据处理
	listProce(list: Array<any>, isRefresh: any) {
		// this.previewList = {}
		let previewList: any = {}
		previewList['0'] = '全部'
		let nowTimes: number = new Date().getTime() + this.difference;
		//直播秒杀商品计算开始时间
		list.length > 0 && list.forEach((item: any, index) => {
			item.sellPrice = +item.sellPrice;//将秒杀价字符串转化为数字以免报错
			if (item.activityType == '1') {
				let startTime = item.startTime,//数据是秒级时间戳需要装换为毫秒级
					endTime = item.endTime;//数据是秒级时间戳需要装换为毫秒级

				if (nowTimes >= startTime && nowTimes < endTime) {
					//当前时间大于开始时间小于结束时间是已开始
					item.status = 1;
					item.countDown = endTime - nowTimes;
				} else if (nowTimes >= endTime) {
					//已结束
					item.status = 2;
				} else {
					//未开始
					item.status = 0;
					item.countDown = startTime - nowTimes;
				}
			}
			if (/1868/.test(item.listingTag) && item.yxdShareAwardListingTagDtoList && item.yxdShareAwardListingTagDtoList.length>0 && isRefresh) {
				let awardAmount = 0,currentCommissionTotal=(item.listingSettlementInfoDto && Number(item.listingSettlementInfoDto.yzgTotalCommission)) || 0,commission:any = currentCommissionTotal;
				for (let yj = 0; yj < item.yxdShareAwardListingTagDtoList.length; yj++) {
					let yjItem = item.yxdShareAwardListingTagDtoList[yj];
					if (yjItem.startTime <= nowTimes && yjItem.endTime >= nowTimes && !yjItem.limitType) {
					// 	if (/1972/.test(item.listingTag) && yjItem.commissionSplit  ==  1) {//拆分佣金翻倍
					// 		item.listingSettlementInfoDto.yzgTotalCommission = Number(yjItem.originalAmount)
					// 		awardAmount += Number(yjItem.splitAmount)
					// 	} else{
					// 		awardAmount += Number(yjItem.awardAmount)
					// 	}
						if (yjItem.commissionSplit == '1' && /1972/.test(item.listingTag)) {
							commission = (Math.ceil(currentCommissionTotal * yjItem.doublingFactor * 100) / 100).toFixed(2)
							awardAmount = Number(currentCommissionTotal) - commission
						} else {
							if(yjItem.awardRoute == 0){//商品标准
								let doublingFactor = currentCommissionTotal
								if(yjItem.doublingFactor) doublingFactor = this.roundUpToTwoDecimalPlaces(doublingFactor * yjItem.doublingFactor)
								if(yjItem.maxComLimit){
									awardAmount += Number(doublingFactor>yjItem.maxComLimit?yjItem.maxComLimit:doublingFactor)	
								} else {
									awardAmount += Number(doublingFactor)
								}
							} else {//配置标准
								awardAmount += Number(yjItem.awardAmount)
							}
						}
					}

				}	
				item.listingSettlementInfoDto.commission = this.roundUpToTwoDecimalPlaces(commission)
				item.listingSettlementInfoDto.doubleCommission = this.roundUpToTwoDecimalPlaces(awardAmount)
			} else if (item.listingSettlementInfoDto) {
				item.listingSettlementInfoDto.commission = this.roundUpToTwoDecimalPlaces(item.listingSettlementInfoDto.yzgTotalCommission)
			}	
			if (item.cusCategoryName && item.cusCategoryName.length>0) {
				item.cusCategoryName.forEach((gory:any) => {
					previewList[gory] = gory
				});
			} else if (item.categoryName) {
				previewList[`${item.categoryName}`] = item.categoryName
			}
		})
		if (isRefresh) {
			let index: any = this.activeIndex
			if (!previewList[index]) {
				this.activeIndex = '0'
			}
			this.previewList = previewList
		}
		list.forEach((listItem: any, inx: number, arr: any) => {
			this.hotGoodLists.forEach((hotItem: any) => {   // 设置爆款商品，并排序
				if (hotItem.listId == listItem.listId) {
					listItem['isExplosives'] = true
					listItem['sortNum'] = hotItem.sortNum
				}
			})
			if (!listItem['sortNum']) {
				if (listItem.storage<=0) {
					listItem['sortNum'] = 999999
				} else 
				listItem['sortNum'] = 999998
			}
		})
		list = list.sort((a, b) => (a.sortNum - b.sortNum))
		return list;
	}
	// goSearch(){ // 搜索
	// }
	searchClk() {
		let burialPoint = {
			url: location.href,
			ule_title: '直播间商品列表弹窗',
			module_name: '直播间商品列表',
			scene_number: this.roomData.scene_number,
			roomNumber: this.$route.params.roomNumber,
			button_name: '搜索',
			remarks: this.$route.params.roomNumber,
			link_url: ''
		}
		_com.sendSensorTrack('btnClick', {}, burialPoint)
		this.searchBox = false
	}
	goOrder() { // 订单
		let burialPoint = {
			url: location.href,
			ule_title: '直播间商品列表弹窗',
			module_name: '直播间商品列表',
			scene_number: this.roomData.scene_number,
			roomNumber: this.$route.params.roomNumber,
			button_name: '订单',
			remarks: this.$route.params.roomNumber,
			link_url: ''
		}
		// 邮乐优鲜小程序
		if (this.browser.usqxcx) {
			if(this.browser.usqxcx=='2003'){
				(<any>window).wx.miniProgram.navigateTo({ url: `/packageA/order/allOrder` })//订单列表
				_com.sendSensorTrack(this.roomData, burialPoint, true, 'yshPoint')
				return
			}
			(<any>window).wx.miniProgram.navigateTo({ url: `/packageA/order/orderList/index` })//订单列表
			_com.sendSensorTrack(this.roomData, burialPoint, true, 'yshPoint')
			return
		}

		if (this.roomData.tvType == 7) { // 主题卡
			burialPoint['link_url'] = 'https://ycst.' + this.environment + '/fenqiztk/#/order/list?bqkey=fq&origin=' + this.environmentUrl + '&act=' + this.urlData['act']
			_com.sendSensorTrack('btnClick', {}, burialPoint)
			location.href = 'https://ycst.' + this.environment + '/fenqiztk/#/order/list?bqkey=fq&origin=' + this.environmentUrl + '&act=' + this.urlData['act'];
			return
		} else if (this.roomData.tvType == 8) { // 分期
			burialPoint['link_url'] = 'https://ycst.' + this.environment + '/fenqi/#/order/list?bqkey=fq&origin=' + this.environmentUrl + '&act=' + this.urlData['act'];
			_com.sendSensorTrack('btnClick', {}, burialPoint)
			location.href = 'https://ycst.' + this.environment + '/fenqi/#/order/list?bqkey=fq&origin=' + this.environmentUrl + '&act=' + this.urlData['act'];
			return
		}
		if (this.browser.yshapp) { // app
			var data = JSON.stringify({ "pageUrl": "/myCenter/orderCenter/myOrderListPage.html", "pageParams": { "tag": "all" }, "pageCloseStatus": false });
			burialPoint['link_url'] = "callApp('thirdH5_goToPage','goToPage','" + data + "')";
			_com.sendSensorTrack('btnClick', {}, burialPoint),
				(<any>window).Emp.execute("callApp('thirdH5_goToPage','goToPage','" + data + "')");

		} else if (this.$route.query.from == 'yshmp') {//邮生活小程序
			burialPoint['link_url'] = "/pages/orderPages/orderList";
			_com.sendSensorTrack('btnClick', {}, burialPoint),
				(<any>window).wx.miniProgram.navigateTo({ url: '/pages/orderPages/orderList' })//订单列表
		} else if (this.source == "ysh") {
			if (this.domain.indexOf('beta') >= 0 || this.domain.indexOf('testing') >= 0) {
				burialPoint['link_url'] = 'http://youshenghuo.trial.cpsdc.com.cn/wx/#/orderList?status=0'
				_com.sendSensorTrack('btnClick', {}, burialPoint),
					location.href = 'http://youshenghuo.trial.cpsdc.com.cn/wx/#/orderList?status=0'
			} else {
				burialPoint['link_url'] = 'https://youshenghuo.11185.cn/wx/#/orderList?status=0'
				_com.sendSensorTrack('btnClick', {}, burialPoint),
					location.href = 'https://youshenghuo.11185.cn/wx/#/orderList?status=0'
			}
		} else if (this.browser.ylxdsq) {//优鲜app跳转我的订单
			burialPoint['link_url'] = "action&&ui.UleOrderActivity##fragment::1";
			_com.sendSensorTrack('btnClick', {}, burialPoint),
				(window as any).dsBridge && (window as any).dsBridge.call("generalAction", { "type": "3", "ios_action": "US_OrderOnlyMyPageVC::0&&TAB::1", "android_action": "action&&ui.UleOrderActivity##fragment::1" })
		} else {
			burialPoint['link_url'] = "//m" + this.domain + "/maftersale/order/list?orderStatus=0";
			_com.sendSensorTrack('btnClick', {}, burialPoint),
				location.href = "//m" + this.domain + "/maftersale/order/list?orderStatus=0";
		}

	}
	goCart() { // 购物车
		if (this.roomData.tvType == 9) {//非试点优鲜
			this.$store.dispatch("environment/getYlxdsqCartAsync", true);
			// this.close()
			return
		}		
		let burialPoint = {
			url: location.href,
			ule_title: '直播间商品列表弹窗',
			module_name: '直播间商品列表',
			button_name: '购物车',
			scene_number: this.roomData.scene_number,
			roomNumber: this.$route.params.roomNumber,
			remarks: this.$route.params.roomNumber,
			link_url: ''
		}
		// 邮乐优鲜小程序
		if (this.browser.usqxcx) {
			if(this.browser.usqxcx=='2003'){
				//四合一优鲜小程序
				(<any>window).wx.miniProgram.switchTab({ url: `/ylyx/cart/cart` })//购物车列表
				_com.sendSensorTrack(this.roomData, burialPoint, true, 'yshPoint')
				return
			}
			(<any>window).wx.miniProgram.switchTab({ url: `/pages/cartList/index` })//购物车列表
			_com.sendSensorTrack(this.roomData, burialPoint, true, 'yshPoint')
			return
		}

		//进进货单
		if (this.roomData.tvType == 7) { // 主题卡
			burialPoint['link_url'] = 'https://ycst.' + this.environment + '/fenqiztk/#/cart?bqkey=fq&origin=' + this.environmentUrl + '&act=' + this.urlData['act'];
			_com.sendSensorTrack(this.roomData, burialPoint, true, 'yshPoint')
			location.href = 'https://ycst.' + this.environment + '/fenqiztk/#/cart?bqkey=fq&origin=' + this.environmentUrl + '&act=' + this.urlData['act'];
			return
		}
		(<any>event).stopPropagation();
		//  this.$router.push({ path: '/ShoppingCart' })
		if (this.browser.ulexcx && this.browser.ulexcx > 2000) {//新版邮乐商城小程序
			(<any>window).wx.miniProgram.navigateTo({ url: '/pages/cart/cart' })
		} else if (this.source == "ule") {
			// 邮乐商城
			burialPoint['link_url'] = "//h5" + this.domain + "/mall/cart";
			_com.sendSensorTrack(this.roomData, burialPoint, true, 'yshPoint')
			location.href = "//h5" + this.domain + "/mall/cart";
		} else if (this.source == "uxd") {
			if (this.browser.ylxd || this.browser.yzg || (cookie.get('sub_sch') == 'jinfuxiaodian')) {
				burialPoint['link_url'] = "//h5" + this.domain + "/yxd/mall/cart/newCartlist?back=true&storeid=" + this.useronlyid + '&shareId=' + (this.$route.query.shareId || '');
				_com.sendSensorTrack(this.roomData, burialPoint, true, 'yshPoint')
				location.href = "//h5" + this.domain + "/yxd/mall/cart/newCartlist?back=true&storeid=" + this.useronlyid + '&shareId=' + (this.$route.query.shareId || '');
			} else if (this.$route.query.storeid && this.$route.query.shareId) {
				burialPoint['link_url'] = "//m" + this.domain + "/mxiaodian/cart/list.html?clientCallType=H5&store_id=" + this.$route.query.storeid;
				_com.sendSensorTrack(this.roomData, burialPoint, true, 'yshPoint')
				location.href = "//m" + this.domain + "/mxiaodian/cart/list.html?clientCallType=H5&store_id=" + this.$route.query.storeid;
			} else {
				burialPoint['link_url'] = "//h5" + this.domain + "/mall/cart?clientCallType=H5";
				_com.sendSensorTrack(this.roomData, burialPoint, true, 'yshPoint')
				location.href = "//h5" + this.domain + "/mall/cart?clientCallType=H5";
			}
			// 邮乐小店（先不加）
			// location.href = "//m" + this.domain + "/mxiaodian/cart/list.html?clientCallType=H5&store_id=" + this.useronlyid;
		} else if (this.source == "usq") {
			// 邮乐优鲜
			burialPoint['link_url'] = "//h5" + this.domain + "/yxd/community/cart/cartList?" + this.clientType;
			_com.sendSensorTrack(this.roomData, burialPoint, true, 'yshPoint')
			location.href = "//h5" + this.domain + "/yxd/community/cart/cartList?" + this.clientType;
		} else if (this.source == "uzg") {
			burialPoint['link_url'] = "//www" + this.domain + "/app/yzg/wholesale_h5/index.html#/ShoppingCart";
			_com.sendSensorTrack(this.roomData, burialPoint, true, 'yshPoint')
			location.href = "//www" + this.domain + "/app/yzg/wholesale_h5/index.html#/ShoppingCart";
		} else if (this.source == "ysh") {
			let srcid = 'live_wx_hd_yshhy' // 微信
			let domainName = 'crmUnionLogin'  // 微信
			if (this.$route.query.from == 'yshmp') { // 邮生活小程序
				srcid = 'live_mini_wx_hd_yshhy'
				domainName = 'yshUnionLogin'
			}
			if (this.browser.yshapp) { // 邮生活app
				srcid = 'live_app_hd_yshhy'
				domainName = 'yshUnionLogin'
				let dataApp = {
					"closeCurrentPage": "0",
					"realName": "0",
					"appid": this.domain == '.beta.ule.com' ? '0f6258b721d04abc96c893cf84740fb2' : '8c8d70950ed04e1a9516559d35b784fc',
					"targetUrl": `https://m${this.domain}/mthirdparty/tp/${domainName}?redirectUrl=${encodeURIComponent(window.location.href)}`
				};
				// closeCurrentPage  当前h5页面是否关闭 0=不关闭；1=关闭
				// realName  是否需要实名校验 0=不需要；1=需要
				// targetUrl 联合登陆后跳转地址
				(<any>window).Emp.execute("callApp('thirdH5_goToJointLogin','goToJointLogin','" + JSON.stringify(dataApp) + "')");
			}
			let url = `https://chinapost${this.domain}/checkoutwap/yshcart/index.do?srcid=${srcid}`
			burialPoint['link_url'] = `https://m${this.domain}/mthirdparty/tp/${domainName}?redirectUrl=${encodeURIComponent(url)}`
			_com.sendSensorTrack('btnClick', this.roomData, burialPoint, true, 'yshPoint')
			location.href = `https://m${this.domain}/mthirdparty/tp/${domainName}?redirectUrl=${encodeURIComponent(url)}`
		}
	}
	searchChange(data: any) {  // 搜索框事件
		if (data.length < 1) return this.searchList = []
		this.searchList = this.goodsList.filter(item =>
			item.listName.includes(data)
		)
	}

	goDetail(goods: any, index?: any) {
		let burialPoint = {
			url: location.href,
			ule_title: '直播间商品列表弹窗',
			resource_type: '直播间商品列表',
			resource_name: '直播间商品列表',
			resource_content: goods.listName,
			resource_module: goods.listName,
			resource_inner_position: index == undefined ? 0 : index + 1,
			resource_item_type: '商品',
			resource_item_id: goods.listId,
			remarks: this.$route.params.roomNumber,
			resource_forward_url: ''
		}
		if (index != undefined) {
			let burialPointClik = {
				url: location.href,
				item_type: '商品',
				item_id: goods.listId,
				// item_name: goods.listName,
				commodity_original_price: goods.priceRange,
				current_page_name: '直播间商品列表弹窗',
				commodity_current_price: '',
				scene_number: this.roomData.scene_number,
				roomNumber: this.$route.params.roomNumber,
				item_explain_status: '',
			}
			// 推荐商品
			if (this.recommendGoods.listId && !this.ifBatchTitle && (this.recommendGoods.categoryName == this.activeIndex ||  this.recommendGoods.cusCategoryName?.includes(this.activeIndex) || this.activeIndex == '0')) {
				burialPointClik['item_explain_status'] == '讲解中'
			} else {
				burialPointClik['item_explain_status'] == ''
			}

			// 商品现价
			if (this.recommendGoods.listId && !this.ifBatchTitle && (this.recommendGoods.categoryName == this.activeIndex ||  this.recommendGoods.cusCategoryName?.includes(this.activeIndex) || this.activeIndex == '0')) { // 讲解中
				if (this.recommendGoods.activityType == '1' && (this.roomData.tvType != 7 && this.roomData.tvType != 8)) {
					if (this.recommendGoods.status != 2 && this.recommendGoods.storage > 0) {
						if (this.roomData.tvType == 6) {
							burialPointClik['commodity_current_price'] == this.recommendGoods.goodPoint
						} else {
							burialPointClik['commodity_current_price'] == this.recommendGoods.minPrice
						}
						if (this.recommendGoods.status == 2) {
							burialPointClik['commodity_current_price'] == this.recommendGoods.priceRange
						}
						if (this.recommendGoods.status == 1 && (this.recommendGoods.storage <= 0)) {
							burialPointClik['commodity_current_price'] == this.recommendGoods.priceRange
						}
					}
				} else {
					if (this.roomData.tvType == 6) {
						burialPointClik['commodity_current_price'] == this.recommendGoods.goodPoint
					} else {
						if (this.recommendGoods.afterCouponPrice != 0) {
							burialPointClik['commodity_current_price'] == this.recommendGoods.afterCouponPrice
						} else if (this.roomData.tvType != 7 && this.roomData.tvType != 8) {
							burialPointClik['commodity_current_price'] == this.recommendGoods.minPrice
						} else {
							if (this.roomData.tvType == 7) {
								burialPointClik['commodity_current_price'] == this.recommendGoods.shoppingProduct.equityPrice
							} else if (this.roomData.tvType == 8) {
								burialPointClik['commodity_current_price'] == this.recommendGoods.shoppingProduct.byStagesPrice
							}
							if (this.isShowTag) burialPointClik['commodity_current_price'] == this.recommendGoods.shoppingProduct.retailPrice
						}
					}
				}
			} else { // 购物袋--非讲解中
				if (goods.activityType == '1' && (this.roomData.tvType != 7 && this.roomData.tvType != 8)) {
					if (!goods.isHidePrice && goods.status == 1) {
						if (goods.priceRange) {
							burialPointClik['commodity_current_price'] == goods.priceRange
						} else {
							burialPointClik['commodity_current_price'] == goods.minPrice
						}
					}
					if (this.roomData.tvType == 6) {
						burialPointClik['commodity_current_price'] == goods.goodPoint
					} else {
						burialPointClik['commodity_current_price'] == goods.priceRange
					}
				} else {
					if (this.roomData.tvType == 6) {
						if (!goods.isHidePrice) burialPointClik['commodity_current_price'] == goods.goodPoint
					} else {
						if (goods.afterCouponPrice != 0) {
							if (!goods.isHidePrice) {
								burialPointClik['commodity_current_price'] == goods.afterCouponPrice
							}
						} else if (this.roomData.tvType != 7 && this.roomData.tvType != 8) {
							if (!goods.isHidePrice) {
								burialPointClik['commodity_current_price'] == goods.minPrice
							}
						} else {
							if (this.roomData.tvType == 7) burialPointClik['commodity_current_price'] == goods.shoppingProduct.equityPrice
							if (this.roomData.tvType == 8) burialPointClik['commodity_current_price'] == goods.shoppingProduct.byStagesPrice
							if (this.isShowTag) burialPointClik['commodity_current_price'] == goods.shoppingProduct.retailPrice
						}

					}
				}
			}


			_com.sendSensorTrack('resourceClick', this.roomData, burialPointClik, true, 'yshPoint')
		}
		if (goods.storage <= 0) return
		//去详情
		if (goods.listingState == 2) {
			// if (goods.listingState == 2 || goods.storage <= 0) {
			//已下架   无库存
			return false;
		}
		(<any>event).stopPropagation();
		if (goods.isSale == 0) {//不可售区域点击不跳转
			return false;
		}
		if (this.roomData.tvType == 9 && goods.activityType == '2') {//非试点优鲜
			this.$store.dispatch("environment/getIsGoodsDetailAsync", goods);
			// this.close()
			return
		}
		this.$emit('setCurrentTime');
		let room = this.roomDetail
		let type = '直播'
		if (room.scene_type == 2) {
			type = '录播'
		}
		let unionParams = `union_id=1016039300&union_ref=${this.$route.params.roomNumber}_${room.scene_number}&live_id=${room.id}&live_name=${room.title}&live_type=${type}`
		if (this.$route.query.ul_aid) {
			unionParams += `&ul_aid=${this.$route.query.ul_aid}`
		}
		if (goods.activityType == '1') {
			if (this.$route.query.ylxdFlag) unionParams += '&ylxdFlag=1'
			//直播秒杀商品跳转到直播秒杀页面
			if (this.$route.query.storeid && this.$route.query.shareId) {
				unionParams += `&storeid=${this.$route.query.storeid}&shareId=${this.$route.query.shareId}&client_type=app_ylxd`
			} else if (this.browser.usqxcx) {
				unionParams += '&client_type=miniwx_ulemall'
			}
			location.href = `//h5${this.domain}/item/seckill_live/${goods.listId}.html?${unionParams}&t=${new Date().getTime()}&toSeckillLive=${this.roomData.roomNumber}&activityType=${goods.activityType}`;
			burialPoint['resource_forward_url'] == `//h5${this.domain}/item/seckill_live/${goods.listId}.html?${unionParams}&t=${new Date().getTime()}`
			_com.sendSensorTrack('btnClick', this.roomData, burialPoint, true, 'yshPoint')
			return false;
		}
		if (goods.activityType == '2') {//优鲜接龙  跳转接龙详情页面

			if (goods.activityCode && this.browser.usqxcx) {
				let path = `/packageA/solitaire/index?activityCode=${goods.activityCode}&listId=${goods.listId}&union_id=1016039300&union_ref=${this.$route.params.roomNumber}_${this.roomDetail.scene_number}`;
				if (this.$route.query.storeid && this.$route.query.shareId) {
					path += `&storeid=${this.$route.query.storeid}&shareId=${this.$route.query.shareId}`;
				}				
				(<any>window).wx.miniProgram.navigateTo({ url:  path})
				_com.sendSensorTrack('btnClick', this.roomData, burialPoint, true, 'yshPoint')
				return
			}


			if (goods.activityCode && this.browser.ylxdsq) {
				if (_com.isIos()) {
					location.href = `objc:ulemobile://action&&WebDetailViewController:0&&key:https@@//h5.${process.env.VUE_APP_URI_DOMAIN.substring(1)}/yxd/community/ylsq/editGroup/${goods.activityCode}?listId=${goods.listId}&isCheck=1&union_id=1016039300&union_ref=${this.$route.params.roomNumber}_${this.roomDetail.scene_number}`;
					_com.sendSensorTrack('btnClick', this.roomData, burialPoint, true, 'yshPoint')
					return
				} else if (_com.isAndroid()) {
					location.href = `ulemobile://action&&ui.MyBusinessWebView##load_url::https://h5.${process.env.VUE_APP_URI_DOMAIN.substring(1)}/yxd/community/ylsq/editGroup/${goods.activityCode}?listId=${goods.listId}&isCheck=1&union_id=1016039300&union_ref=${this.$route.params.roomNumber}_${this.roomDetail.scene_number}`;
					_com.sendSensorTrack('btnClick', this.roomData, burialPoint, true, 'yshPoint')
					return
				}
			}
			location.href = `//h5${this.domain}/yxd/community/chains/chainsDetail/${goods.activityCode}?listId=${goods.listId}&${unionParams}&${this.roomData.roomNumber}`;
			burialPoint['resource_forward_url'] = `//h5${this.domain}/yxd/community/chains/chainsDetail/${goods.activityCode}?listId=${goods.listId}&${unionParams}`;
			_com.sendSensorTrack('btnClick', this.roomData, burialPoint, true, 'yshPoint')
			return false;
		}
		if (goods.link) {//跳转中转页
			sessionStorage.setItem("from", "true");
			let params;
			if (this.$route.query.storeid)
				params = '?storeid=' + this.$route.query.storeid;
			this.$router.push({
				path: goods.link + '/' + goods.listId + '/' + this.source + params
			});
			return false;
		}
		if (this.roomData.tvType == 7) { // 主题卡直播
			location.href = 'https://ycst.' + this.environment + '/fenqiztk/#/detail/' + goods.shoppingProduct.goodId + '/' + goods.listId + '?bqkey=fq&origin=' + this.environmentUrl + '&act=' + this.urlData['act'] + '&toSeckillLive=' + this.roomData.roomNumber + '&activityType=' + goods.activityType
			burialPoint['resource_forward_url'] = 'https://ycst.' + this.environment + '/fenqiztk/#/detail/' + goods.shoppingProduct.goodId + '/' + goods.listId + '?bqkey=fq&origin=' + this.environmentUrl + '&act=' + this.urlData['act'] + '&toSeckillLive=' + this.roomData.roomNumber + '&activityType=' + goods.activityType
			_com.sendSensorTrack('btnClick', {}, burialPoint)
			return
		} else if (this.roomData.tvType == 8) { // 分期直播
			location.href = 'https://ycst.' + this.environment + '/fenqi/#/detail/' + goods.shoppingProduct.goodId + '/' + goods.listId + '?bqkey=fq&origin=' + this.environmentUrl + '&act=' + this.urlData['act'] + '&toSeckillLive=' + this.roomData.roomNumber + '&activityType=' + goods.activityType
			burialPoint['resource_forward_url'] = 'https://ycst.' + this.environment + '/fenqi/#/detail/' + goods.shoppingProduct.goodId + '/' + goods.listId + '?bqkey=fq&origin=' + this.environmentUrl + '&act=' + this.urlData['act'] + '&toSeckillLive=' + this.roomData.roomNumber + '&activityType=' + goods.activityType
			_com.sendSensorTrack('btnClick', {}, burialPoint)
			return
		}
		// 邮乐优鲜小程序
		if (this.browser.usqxcx) {
			if(this.browser.usqxcx=='2003'){
				//四合一优鲜小程序
				let path:String = `/ylyx/item/item?listId=${goods.listId}&union_id=1016039300&union_ref=${this.$route.params.roomNumber}_${room.scene_number}`;
				if (this.$route.query.storeid && this.$route.query.shareId) {
					path += `&storeid=${this.$route.query.storeid}&shareId=${this.$route.query.shareId}`;
				}
				(<any>window).wx.miniProgram.navigateTo({ url:  path })//邮乐优鲜小程序详情页
				_com.sendSensorTrack('btnClick', this.roomData, burialPoint, true, 'yshPoint')
				return 
			}
			let path:String = `/packageA/item/item?listId=${goods.listId}&union_id=1016039300&union_ref=${this.$route.params.roomNumber}_${room.scene_number}`;
			if (this.$route.query.storeid && this.$route.query.shareId) {
				path += `&storeid=${this.$route.query.storeid}&shareId=${this.$route.query.shareId}`;
			}
			(<any>window).wx.miniProgram.navigateTo({ url:  path })//邮乐优鲜小程序详情页
			_com.sendSensorTrack('btnClick', this.roomData, burialPoint, true, 'yshPoint')
			return
		}

		if (this.browser.ulexcx && this.browser.ulexcx > 2000) {//新版邮乐商城小程序
			burialPoint['resource_forward_url'] = `/packageA/item/item?listId=${goods.listId}&${unionParams}`
			_com.sendSensorTrack('btnClick', this.roomData, burialPoint, true, 'yshPoint'),
				(<any>window).wx.miniProgram.navigateTo({ url: `/packageA/item/item?listId=${goods.listId}&${unionParams}` })
		} else if (this.browser.uxdxcx) {
			burialPoint['resource_forward_url'] = `/pages/detail/detail?listingId=${goods.listId}&${unionParams}`
			_com.sendSensorTrack('btnClick', this.roomData, burialPoint, true, 'yshPoint'),
				(<any>window).wx.miniProgram.navigateTo({ url: `/pages/detail/detail?listingId=${goods.listId}&${unionParams}` })
		} else if (this.source == "ule") {
			// 邮乐商城
			if (this.browser.ule) {
				try {
					let adid = this.$route.query.adid || '';
					(window as any).dsBridge.call("generalAction", {
						type: "3",
						ios_action: `UleProductDetailViewController::0&&listId::${goods.listId}##h5_unionId::1016039300##h5_unionRef::${this.$route.params.roomNumber}_${room.scene_number}##h5_adid::${adid}##h5_orderSourceId::`,
						android_action: `ProductActivity&&wgt.PrdDetail&&listId::${goods.listId}##h5_unionId::1016039300##h5_unionRef::${this.$route.params.roomNumber}_${room.scene_number}##h5_adid::${adid}##h5_orderSourceId::`,
						router_action:`prd&&listId::${goods.listId}##h5_unionId::1016039300##h5_unionRef::${this.$route.params.roomNumber}_${room.scene_number}##h5_adid::${adid}##fromH5Vi::true`
					})
				} catch (error) {
					location.href = "uleMobile://uleVi_" + goods.listId + '&toSeckillLive=' + this.roomData.roomNumber + '&activityType=' + goods.activityType;
					burialPoint['resource_forward_url'] = "uleMobile://uleVi_" + goods.listId;
					_com.sendSensorTrack('btnClick', this.roomData, burialPoint, true, 'yshPoint')
				}
			} else {
				burialPoint['resource_forward_url'] = `//item${this.domain}/mitem/item/view/${goods.listId}?${unionParams}`;
				_com.sendSensorTrack('btnClick', {}, burialPoint)
				location.href = `//item${this.domain}/mitem/item/view/${goods.listId}?${unionParams}&toSeckillLive=` + this.roomData.roomNumber + '&activityType=' + goods.activityType;
			}
		} else if (this.source == "uxd") {
			// 邮乐小店
			if (this.browser.wxwork) {
				burialPoint['resource_forward_url'] = `//h5${this.domain}/yxd/mall/item/app/${goods.listId}?isBuy=false&storeid=${this.useronlyid}&imageType=xl&client_type=app_ylxd&preview=1&${unionParams}`;
				_com.sendSensorTrack('btnClick', {}, burialPoint)
				location.href = `//h5${this.domain}/yxd/mall/item/app/${goods.listId}?isBuy=false&storeid=${this.useronlyid}&imageType=xl&client_type=app_ylxd&preview=1&${unionParams}&toSeckillLive=` + this.roomData.roomNumber + '&activityType=' + goods.activityType;
			} else if (this.browser.ylxd || this.browser.ylxdsq || this.browser.yzg || this.browser.zyet) {
				burialPoint['resource_forward_url'] = `//h5${this.domain}/yxd/mall/item/app/${goods.listId}?storeid=${this.useronlyid}&imageType=xl&client_type=app_ylxd&preview=1&${unionParams}`;
				_com.sendSensorTrack('btnClick', this.roomData, burialPoint, true, 'yshPoint')
				location.href =
					`//h5${this.domain}/yxd/mall/item/app/${goods.listId}?storeid=${this.useronlyid}&imageType=xl&client_type=app_ylxd&preview=1&${unionParams}&toSeckillLive=` + this.roomData.roomNumber + '&activityType=' + goods.activityType;
			} else if (cookie.get('sub_sch') == 'jinfuxiaodian') {
				burialPoint['resource_forward_url'] = `//h5${this.domain}/yxd/mall/item/app/${goods.listId}?storeid=${this.useronlyid}&imageType=xl&client_type=app_ylxd&preview=1&${unionParams}`;
				_com.sendSensorTrack('btnClick', this.roomData, burialPoint, true, 'yshPoint')
				location.href =
					`//h5${this.domain}/yxd/mall/item/app/${goods.listId}?storeid=${this.useronlyid}&imageType=xl&client_type=app_ylxd&preview=1&${unionParams}&toSeckillLive=` + this.roomData.roomNumber + '&activityType=' + goods.activityType;
			} else if (this.$route.query.storeid && this.$route.query.shareId) {
				burialPoint['resource_forward_url'] = `//h5${this.domain}/yxd/mall/item/web/${goods.listId}?storeid=${this.$route.query.storeid}&shareId=${this.$route.query.shareId}&imageType=xl&client_type=app_ylxd&adid=ylxdfx_merchant&preview=1&${unionParams}&activityType=${goods.activityType}`;
				_com.sendSensorTrack('btnClick', this.roomData, burialPoint, true, 'yshPoint')
				location.href =
					`//h5${this.domain}/yxd/mall/item/web/${goods.listId}?storeid=${this.$route.query.storeid}&shareId=${this.$route.query.shareId}&imageType=xl&client_type=app_ylxd&adid=ylxdfx_merchant&preview=1&${unionParams}&toSeckillLive=${this.roomData.roomNumber}&activityType=${goods.activityType}`;
			} else if (this.browser.usqxcx) {//优鲜小程序内跳转大网详情页时带上client_type=miniwx_ulemall  详情页重写cookie  
				burialPoint['resource_forward_url'] = `//item${this.domain}/mitem/item/view/${goods.listId}?client_type=miniwx_ulemall&${unionParams}`;
				_com.sendSensorTrack('btnClick', {}, burialPoint)
				location.href = `//item${this.domain}/mitem/item/view/${goods.listId}?client_type=miniwx_ulemall&${unionParams}&toSeckillLive=${this.roomData.roomNumber}&activityType=${goods.activityType}`;
			} else {
				burialPoint['resource_forward_url'] = `//item${this.domain}/mitem/item/view/${goods.listId}?${unionParams}`;
				_com.sendSensorTrack('btnClick', {}, burialPoint)
				location.href = `//item${this.domain}/mitem/item/view/${goods.listId}?${unionParams}&toSeckillLive=${this.roomData.roomNumber}&activityType=${goods.activityType}`;
			}
		} else if (this.source == "usq") {
			// 邮乐优鲜
			if (this.$route.query.storeid && this.$route.query.shareId) {
				burialPoint['resource_forward_url'] = "//h5" +
					this.domain +
					"/yxd/community/item/itemPage/" +
					goods.listId +
					"?union_id=1016039300&union_ref=" +
					this.$route.params.roomNumber + '_' + room.scene_number +
					"&storeid=" +
					this.$route.query.storeid +
					"&shareId=" +
					this.$route.query.shareId;
				_com.sendSensorTrack('btnClick', this.roomData, burialPoint, true, 'yshPoint')
				location.href =
					"//h5" +
					this.domain +
					"/yxd/community/item/itemPage/" +
					goods.listId +
					"?union_id=1016039300&union_ref=" +
					this.$route.params.roomNumber + '_' + room.scene_number +
					"&storeid=" +
					this.$route.query.storeid +
					"&shareId=" +
					this.$route.query.shareId + '&toSeckillLive=' + this.roomData.roomNumber + '&activityType=' + goods.activityType;
			} else {
				burialPoint['resource_forward_url'] = "//h5" + this.domain + "/yxd/community/item/itemPage/" + goods.listId + "?union_id=1016039300&union_ref=" + this.$route.params.roomNumber + '_' + room.scene_number;
				_com.sendSensorTrack('btnClick', {}, burialPoint)
				location.href = "//h5" + this.domain + "/yxd/community/item/itemPage/" + goods.listId + "?union_id=1016039300&union_ref=" + this.$route.params.roomNumber + '_' + room.scene_number + '&toSeckillLive=' + this.roomData.roomNumber + '&activityType=' + goods.activityType;
			}
		} else if (this.source == "uzg") {
			burialPoint['resource_forward_url'] = "//www" + this.domain + "/app/yzg/wholesale_h5/index.html#/GoodsDetails/" + goods.listId + '?scene_id=' + room.scene_id + '&roomNumber=' + room.roomNumber + '&scene_number=' + room.scene_number;
			_com.sendSensorTrack('btnClick', {}, burialPoint)
			location.href = "//www" + this.domain + "/app/yzg/wholesale_h5/index.html#/GoodsDetails/" + goods.listId + '?scene_id=' + room.scene_id + '&roomNumber=' + room.roomNumber + '&scene_number=' + room.scene_number + '&toSeckillLive=' + this.roomData.roomNumber + '&activityType=' + goods.activityType;
		} else if (this.source == "ysh") { // 邮生活直播
			let pointSuppilersId = (this.domain.indexOf('beta') >= 0 || this.domain.indexOf('testing') >= 0) ? 3607 : 3031
			let from = '' // 微信
			if (this.$route.query.from == 'yshmp') from = 'yshmp' // 邮生活小程序
			if (this.browser.yshapp) {
				from = 'yshapp' // 邮生活app
				let srcid = 'live_app_hd_yshhy'
				let domainName = 'yshUnionLogin'
				let dataApp = {
					"closeCurrentPage": "0",
					"realName": "0",
					"appid": this.domain == '.beta.ule.com' ? '0f6258b721d04abc96c893cf84740fb2' : '8c8d70950ed04e1a9516559d35b784fc',
					"targetUrl": `https://m${this.domain}/mthirdparty/tp/${domainName}?redirectUrl=${encodeURIComponent(window.location.href)}`
				};
				// closeCurrentPage  当前h5页面是否关闭 0=不关闭；1=关闭
				// realName  是否需要实名校验 0=不需要；1=需要
				// targetUrl 联合登陆后跳转地址
				(<any>window).Emp.execute("callApp('thirdH5_goToJointLogin','goToJointLogin','" + JSON.stringify(dataApp) + "')");
			}
			let url = `https://item${this.domain}/pointitem/ysh/${goods.listId}-0-1.html?pointSupplierId=${pointSuppilersId}&from=${from}&operationSource=6&union_id=1016039300&union_ref=${this.$route.params.roomNumber}_${room.scene_number}&adid=ylxdfx_merchant`
			// if(this.getcookie('crmMemberInfo')){
			// }else{
			burialPoint['resource_forward_url'] = url
			_com.sendSensorTrack('btnClick', {}, burialPoint)
			location.href = url + '&toSeckillLive=' + this.roomData.roomNumber
			// location.href = `https://m${this.domain}/mthirdparty/tp/crmUnionLogin?redirectUrl=${encodeURIComponent(url)}`
			// }
		}
		// 点击埋点
		_com.sendSensorTrack('ItemClick', room, {
			module_sort: index,
			listId: goods.listId,
			listName: goods.listName,
			minPrice: goods.minPrice
		})
	}
	volumeShop() {
		let listIdArr: any = [];
		for (var i = 0; i < this.goodsList.length; i++) {
			if (this.goodsList[i].activityType != '1') {//秒杀不能用券
				listIdArr.push(this.goodsList[i].listId);
			}
		}
		if (this.batchObj.batchId && this.batchObj.batchId != "") {
			let batchId = this.batchObj.batchId;
			this.batchTitle = this.batchObj.title;
			this.$store.dispatch("environment/setBatchObjAsync", {});
			this.$http
				.jsonp("//ustatic" + process.env.VUE_APP_URI_ULECDNDOMAIN + "/mobileactcdn/item/queryListIsMatchCoupon2/queryList212/" + batchId + "/" + listIdArr.join("-"), {
					jsonp: "jsonpCallback",
					jsonpCallback: "queryList212",
				})
				.then((data: any) => {
					console.log(data.body);
					if (data.body.returnCode && data.body.data ) {
						if (data.body.data.listIds && data.body.data.listIds.length > 0) {
							//判断是否有优惠卷相对应的商品
							this.$store.dispatch("environment/getIsGoodsListAsync", true);
							this.$store.dispatch("environment/getIfBatchTitleAsync", true);
							this.shopGoods = data.body.data.listIds.join(",");
						} else {
							this.shopGoods = listIdArr.join(",");
							if (data.body.data.listingTags && data.body.data.listingTags.includes(this.$route.params.roomNumber)) {
								this.$store.dispatch("environment/getIsGoodsListAsync", true);
								this.$store.dispatch("environment/getIfBatchTitleAsync", true);
							} else {
								this.$store.dispatch("environment/getIfBatchTitleAsync", false);
								this.$toast({
									message: "没有该优惠卷关联商品！",
									className: "topIndex",
									position: "bottom",
									duration: 2000,
								});
							}
						}
					} else {
						this.shopGoods = listIdArr.join(",");
						this.$store.dispatch("environment/getIfBatchTitleAsync", false);
						this.$toast({
							message: "没有该优惠卷关联商品！",
							className: "topIndex",
							position: "bottom",
							duration: 2000,
						});
					}
				});
		} else {
			this.$store.dispatch("environment/getIfBatchTitleAsync", false);
			this.shopGoods = listIdArr.join(",");
		}
	}

	stop(e: any) {
		e.stopPropagation();
	}

	close() {
		this.$store.dispatch("environment/getIsGoodsListAsync", false);
	}
}
